import { helpers, ts } from '_core';

const cellMergeCondition = (row: Record<string, any>) => {
  const initialValue = row.initial;
  const diffValue = row.diff;
  return row.id && !initialValue && !diffValue;
};

const mergeColumnsFormatter = (value: unknown, row: Record<string, any>) => {
  if (cellMergeCondition(row)) {
    return row.optimal;
  }
  return value;
};

export default {
  rebalance: [
    {
      key: 'label',
      name: '',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      isFixed: true,
    },
    {
      key: 'metric',
      name: 'Metric',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
    },
    {
      key: 'initial',
      name: 'Previous',
      formatter: helpers.tabularFormatters.formatTo(
        'string',
        { align: 'center', showBlanks: true },
        mergeColumnsFormatter
      ),
      filter: 'number',
      colSpan: (_value: unknown, row: Record<string, any>) => {
        if (cellMergeCondition(row)) {
          return 3;
        }
        return 1;
      },
    },
    {
      key: 'optimal',
      name: 'Optimal',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'right' }),
      filter: 'number',
      colSpan: (_value: unknown, row: Record<string, any>) => {
        if (cellMergeCondition(row)) {
          return 0;
        }
        return 1;
      },
    },
    {
      key: 'diff',
      name: 'Change',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        multiplier: 100,
        suffix: '%',
        commasOnThousands: true,
        showBlanks: true,
      }),
      filter: 'number',
      colSpan: (_value: any, row: any) => {
        if (cellMergeCondition(row)) {
          return 0;
        }
        return 1;
      },
    },
  ] as ts.types.components.dataGrid.ColumnsData,
  trade: [
    {
      key: 'label',
      name: '',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      isFixed: true,
    },
    {
      key: 'metric',
      name: 'Metric',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
    },
    {
      key: 'value',
      name: 'Value (USD)',
      formatter: helpers.tabularFormatters.formatTo('integer', {
        align: 'right',
        prefix: '$',
        commasOnThousands: true,
      }),
      filter: 'number',
    },
    {
      key: '%',
      name: '% of Gross Exposure',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        multiplier: 100,
        suffix: '%',
        commasOnThousands: true,
      }),
      filter: 'number',
    },
    {
      key: 'trade_count',
      name: 'Trade Count',
      formatter: helpers.tabularFormatters.formatTo('integer', { align: 'right', commasOnThousands: true }),
      filter: 'number',
    },
    {
      key: 'share_count',
      name: 'Share Count',
      formatter: helpers.tabularFormatters.formatTo('integer', { align: 'right', commasOnThousands: true }),
      filter: 'number',
    },
    {
      key: 'average_price_share',
      name: 'Average Price/Share',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        prefix: '$',
      }),
      filter: 'number',
    },
    {
      key: 'forecast_cost',
      name: 'Forecast Cost',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        multiplier: 100,
        suffix: '%',
        commasOnThousands: true,
      }),
      filter: 'number',
    },
  ] as ts.types.components.dataGrid.ColumnsData,
};
